const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/dashboards/$dashboardId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
const paramsSchema = z.object({
  dashboardId: z.coerce.number().int().positive()
});
export const Route = createFileRoute('/(app)/org/$org/dashboards/$dashboardId/')({
  params: paramsSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});